import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell.component';
import { shellRouting } from './shell.routing';
import { ShellGuard } from './shell.guard';
import { SharedModule } from '../core/shared/shared.module';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SidebarMenuModule } from './sidebar-menu/sidebar-menu.module';
import { ShellSideNavService } from './shell-sidenav.service';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { LayoutSettingsComponent } from './layout-settings/layout-settings/layout-settings.component';
import { FooterComponent } from './footer/footer.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ProfilePictureSelectionComponent } from './profile-picture-selection/profile-picture-selection.component';

@NgModule({
  imports: [
    CommonModule,
    shellRouting,
    SharedModule,
    SidebarMenuModule
  ],
  declarations: [
    ShellComponent,
    BreadcrumbsComponent,
    UserMenuComponent,
    LayoutSettingsComponent,
    FooterComponent,
    SpinnerComponent,
    ProfilePictureSelectionComponent
  ],
  providers: [
    ShellGuard,
    ShellSideNavService
  ]
})
export class ShellModule { }
